const blogs = [
    {
        id: '1',
        title: 'Understanding the Importance of Regular Health Checkups',
        title2: 'Why Routine Medical Exams Can Save Your Life',
        tag: 'Health Tips',
        slug: 'importance-of-regular-health-checkups',
        screens: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&h=400&fit=crop',
        description: 'Regular health checkups are essential for early detection of potential health issues. Learn why scheduling routine visits to your doctor can make a significant difference in your overall well-being.',
        author: 'Dr. Mahinda Jayasooriya',
        create_at: 'Mar 15, 2026',
        blogSingleImg: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&h=600&fit=crop',
        comment: '12',
        day: '15',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Heart Health: Tips for a Stronger Cardiovascular System',
        title2: 'Simple Steps to Keep Your Heart Healthy and Strong',
        tag: 'Cardiology',
        slug: 'heart-health-tips-cardiovascular-system',
        screens: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=600&h=400&fit=crop',
        description: 'Cardiovascular diseases remain one of the leading causes of death worldwide. Discover practical tips and lifestyle changes that can help you maintain a healthy heart.',
        author: 'Dr. Kumari Perera',
        create_at: 'Feb 28, 2026',
        blogSingleImg: 'https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?w=1200&h=600&fit=crop',
        comment: '24',
        day: '28',
        month: 'FEB',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'The Role of Nutrition in Preventing Chronic Diseases',
        title2: 'How a Balanced Diet Can Transform Your Health',
        tag: 'Nutrition',
        slug: 'nutrition-preventing-chronic-diseases',
        screens: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=600&h=400&fit=crop',
        description: 'A well-balanced diet plays a crucial role in preventing chronic diseases such as diabetes, hypertension, and obesity. Learn how proper nutrition can be your best medicine.',
        author: 'Dr. Anil Fernando',
        create_at: 'Feb 10, 2026',
        blogSingleImg: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=1200&h=600&fit=crop',
        comment: '18',
        day: '10',
        month: 'FEB',
        blClass: 'format-standard-image',
        animation: '1200',
    },
];

export default blogs;
